import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import {getMasterData} from '../../actions/index';
import history from '../../../../history';

const validate = (values) => {
  const errors = {};
  if (!values.month) {
    errors.month = 'Please select month.';
  }
  if (!values.year) {
    errors.year = 'Please select year.';
  }
  
  return errors;
};

class NortheasternEarlyStepsEBSReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      MonthList: [{ id: 1, value: 'January' }, { id: 2, value: 'February' },{ id: 3, value: 'March' }, { id: 4, value: 'April' },{ id: 5, value: 'May' }, 
                  { id: 6, value: 'June' },{ id: 7, value: 'July' }, { id: 8, value: 'August' },{ id: 9, value: 'September' }, { id: 10, value: 'October' },
                  { id: 11, value: 'November' }, { id: 12, value: 'December' }],
      YearList: [{ id: 2017, value: '2017' }, { id: 2018, value: '2018' },{ id: 2019, value: '2019' },{ id: 2020, value: '2020' }, { id: 2021, value: '2021' },{ id: 2022, value: '2022' }, 
                  { id: 2023, value: '2023' },{ id: 2024, value: '2024' }, { id: 2025, value: '2025' },{ id: 2026, value: '2026' }, { id: 2027, value: '2027' },
                  { id: 2028, value: '2028' }, { id: 2029, value: '2029' }, { id: 2030, value: '2030' }],
      selectedMonth : 0,
      selectedYear : 0,     
      
      iframeURL: '',
      isLoading: false,
      random: 0,
    };    
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
  }

  componentWillMount() {    
   
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();   
    let REPORT_URL  = GetReportUrl(this.props.agencyName);   
    let reportName = base64Encode('FC_NortheasternEarlyStepsReport_EBS');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "Month","Value": "`+ this.state.selectedMonth + `"},{"Name": "Year","Value": "`+ this.state.selectedYear + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  } 

  handleChange = (input, selectedRecord) => {   
    if (input.name === 'month') {
     this.setState({selectedMonth: selectedRecord.value});
    } else if (input.name === 'year') {
      this.setState({selectedYear: selectedRecord.value});
    }
        
    input.onChange(selectedRecord.value);
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/financial-reports');
  }
  render() {
    const { handleSubmit } = this.props;    
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Financial {' > '} Northeastern Early Steps Report</h2>
        :
          <h2 className="page_title">Northeastern Early Steps Report</h2>
        }  
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">               
                <div className="col-sm-4 require mt-35">
                  <Field name="month"
                    label="Select Month"
                    handleNewRequest={this.handleChange}
                    options={this.state.MonthList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field name="year"
                    label="Select Year"
                    handleNewRequest={this.handleChange}
                    options={this.state.YearList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

NortheasternEarlyStepsEBSReport = reduxForm({
  form: 'NortheasternEarlyStepsEBSReportForm',
  validate,
  enableReinitialize: true,
})(NortheasternEarlyStepsEBSReport);

function mapStateToProps(state) {
  // let locationArr = [];
  // if (state.login.userLocationList) {
  //   locationArr = (state.login.userLocationList).map((obj) => {
  //     return (
  //       {
  //         id: obj.id,
  //         value: obj.locationName,
  //       }
  //     );
  //   });
  // }
// console.log('state.report.master_data............',state.report.master_data.allStaffs)
  return {
    orgID: state.login.loginUserInfo.organizationID,    
   // userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {getMasterData})(NortheasternEarlyStepsEBSReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/FinancialReports/NortheasternEarlyStepsEBSReport.js